import FlaskBar from '../../../../../components/dashboard/flask-bar/FlaskBar'
import IconEnergy from '../../../../../components/common/icon/IconEnergy'
import { Trans } from '@lingui/macro'
import React from 'react'
import { DashboardActionTypeReport } from 'front-end/src/graphql/private/PrivateSchemaTypes'
import { TooltipHelpQuestion } from 'front-end/src/components/common/tooltip/TooltipHelp'
import './ActionsBox.less'

interface IActionsBoxProps {
  actionsData: Array<DashboardActionTypeReport>
  totalActionsCount: number
}

const ActionsBox = ({ actionsData, totalActionsCount }: IActionsBoxProps) => {
  return (
    <div className="DataSummaryGrid__item">
      <div className="Box ActionsBox">
        <div className="ActionsBox__title">
          <IconEnergy />
          <Trans>Actions</Trans>
          <div className="ActionsBox__title__number">{totalActionsCount}</div>
          <div className="ActionsBox__title__desc">
            <Trans>Effectiveness of comms</Trans>
          </div>
          <TooltipHelpQuestion>
            <Trans>
              This shows the % click rate for each action to help you see which
              action are most effective for your target audience.
            </Trans>
          </TooltipHelpQuestion>
        </div>
        <div className="ActionsBox__graph">
          {actionsData.map((data, index) => (
            <FlaskBar
              key={index}
              percentage={
                typeof data.effectiveness === 'number'
                  ? data.effectiveness
                  : null
              }
              tooltipText={getTooltipText(data)}
              title={data.commName}
            />
          ))}
        </div>
      </div>
    </div>
  )
}

const getTooltipText = (data: DashboardActionTypeReport) => {
  if (!data.isCommEnabled) {
    return <Trans>Inactive comm</Trans>
  }

  if (data.effectiveness === null) {
    return <Trans>No data</Trans>
  }

  return (
    <>
      <Trans>Effectiveness</Trans>: {data.effectiveness}% <br />{' '}
      {data.userEventsCount}/{data.processedActionsCount}
    </>
  )
}

export default ActionsBox
